import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Panel, Form, Message } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import CustomIconMessageInfo from '../CustomIconMessageInfo'
import { startLoading, doneLoading } from '../../utils/loading'
import CKEditorFrom from '../../components/forms/input/CKEditorFrom'
import {
  getProgessActivity,
  updateProgessActualActivity,
  saveProgessActivity,
  updateProgessActivity,
  saveProgressFeedback,
  updateProgressFeedback,
  deleteProgressFeedback,
} from '../../redux/actions/projectProgress'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ProgessActivityForm from './ProgessActivityForm'
import ActivityAddEditWidget from './ActivityAddEditWidget'
import { cloneDeep } from 'lodash'
import CommentForm from './CommentForm'
import CommentView from './CommentView'
import ButtonPanel from '../ButtonPanel'
import WarningMessage from '../../components/message/WarningMessage/WarningMessage'

export default function ProgessActivityWidget({ schema: _schema, ...props }) {
  const { showCommandButton, isEdit, onChangeIsEdit, onAddActivity } = props
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [progressId, setProgressId] = useState()

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // let progressId = location.search.substring(1)
    let progressId = sessionStorage.getItem('param')?.substring(1)
    console.log('ProgessActivityWidget', _schema, 'progressId', progressId)
    setProgressId(progressId)
    setFormSchema(_schema)
  }, [_schema])

  const handleUpdateProgessActualActivity = async (request, projectProgressId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      console.log('call update.')
      const response = await updateProgessActualActivity(projectId, projectProgressId, request)

      console.log('response', response)

      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDeleteProgessActivity = async (request, projectProgressId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      console.log('call delete.')
      const response = await updateProgessActivity(projectId, projectProgressId, request)

      console.log('response', response)

      if (response) {
        //onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallCommentService = async (request, projectProgressId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      if (request.value.value || request.value.id) {
        if (request.value.value) {
          let response

          if (request.value.id) {
            console.log('call update.')
            response = await updateProgressFeedback(projectId, projectProgressId, request)
          } else {
            console.log('call save.')
            response = await saveProgressFeedback(projectId, projectProgressId, request)
          }

          console.log('response', response)
          if (response) {
            onChangeIsEdit(false)
            let _schema = formSchema
            _schema.comment = response
            setFormSchema(_schema)
          } else {
            setIsError(true)
          }
        } else {
          let deleteResult = await deleteProgressFeedback(
            projectId,
            projectProgressId,
            request.value.id
          )

          if (deleteResult == 200) {
            let _schema = await getProgessActivity(projectId, projectProgressId)
            console.log('getProgessActivity', _schema)
            onChangeIsEdit(false)
            setFormSchema(_schema)
          } else {
            setIsError(true)
          }
        }
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let values = []
    Object.keys(data).map(function (key, index) {
      if (key) {
        let _data = {
          id: key,
          result: data[key],
        }
        values.push(_data)
      }
    })

    console.log('values', values)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      //userId: "string",
      projectProgressId: progressId,
      values: values,
    }

    console.log('request body', request)
    handleUpdateProgessActualActivity(request, progressId)
  }

  const onSubmitComment = (data) => {
    console.log('onSubmitComment', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      projectProgressId: progressId,
      masterSubjectId: formSchema.comment.masterSubjectId,
      value: {
        id: formSchema.comment.id,
        value: data.comment,
      },
    }

    console.log('request body', request)
    handleCallCommentService(request, progressId)
  }

  const onDeleteActivity = (data) => {
    // let _data = data
    // _data.isDelete = true

    let request = {
      id: formSchema.id,
      projectVersionId: projectId,
      //userId: "string",
      projectProgressId: progressId,
      values: {
        id: data.id,
        activity: data.activity,
        activityDetail: data.activityDetail,
        activityDurationDate: data.activityDurationDate,
        underPurpose: data.underPurpose.value,
        isDelete: true,
      },
    }

    console.log('request body', request)
    handleDeleteProgessActivity(request, progressId)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      {formSchema?.comment?.enableEdit ? (
        <>
          <div>
            {formSchema.values?.map((item, index) => {
              return (
                <div key={index}>
                  <p>
                    <b>
                      {'กิจกรรมที่ ' + (index + 1)} {item.activity}
                    </b>
                  </p>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;{item.activityDetail}</p>
                  <p>{item.resultLabel}</p>
                  {/* <p>&nbsp;&nbsp;&nbsp;&nbsp;{item.result || '-โปรดระบุ-'}</p> */}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: '&nbsp;&nbsp;&nbsp;&nbsp;' + item.result || '-โปรดระบุ-',
                    }}
                  />
                  <br />
                </div>
              )
            })}
          </div>

          <hr />

          {isEdit ? (
            <CommentForm
              schema={formSchema.comment}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          ) : (
            <div>
              <CommentView schema={formSchema.comment} />
            </div>
          )}
        </>
      ) : (
        <>
          <WarningMessage style={{ marginBottom: 10 }} message={formSchema?.comment?.value} />

          {isEdit ? (
            <>
              {/* <ActivityAddEditWidget schema={formSchema} onAddSuccess={(e)=>onAddSuccess(e)}/> */}

              <ProgessActivityForm
                schema={formSchema}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                onSuccess={(e) => {
                  setFormSchema(e)
                  onAddActivity()
                }}
                onDelete={(e) => {
                  onDeleteActivity(e)
                }}
              />
            </>
          ) : (
            <div>
              {formSchema?.values?.map((item, index) => {
                return (
                  <div key={index}>
                    <p>
                      <b>
                        {'กิจกรรมที่ ' + (index + 1)} {item.activity}
                      </b>
                    </p>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;{item.activityDetail}</p>
                    <p>
                      <b>{item.resultLabel}</b>
                    </p>
                    {/* <p>&nbsp;&nbsp;&nbsp;&nbsp;{item.result || '-โปรดระบุ-'}</p> */}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: '&nbsp;&nbsp;&nbsp;&nbsp;' + item.result || '-โปรดระบุ-',
                      }}
                    />
                    <br />
                  </div>
                )
              })}
            </div>
          )}
        </>
      )}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={
              formSchema?.comment?.enableEdit
                ? formSchema?.comment?.buttonText
                : formSchema.buttonText
            }
            onSave={handleSubmit(formSchema.comment?.enableEdit ? onSubmitComment : onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}
